import React from 'react';
import ReactDOM from 'react-dom'; // Necessario per createPortal
import Draggable from 'react-draggable'; // Importa Draggable
import VideoPlayerHlsSingoloFlusso from './VideoPlayerHlsSingoloFlusso';
import '../VideoPlayerHls4Flussi.css'; // Assicurati di creare questo file CSS

const VideoPlayerHls4Flussi = ({ baseUrl, serial, onClose }) => {
  if (!baseUrl || !serial) {
    return null;
  }

  const streamUrls = [
    `${baseUrl}/${serial}/stream0/index.m3u8`,
    `${baseUrl}/${serial}/stream1/index.m3u8`,
    `${baseUrl}/${serial}/stream2/index.m3u8`,
    `${baseUrl}/${serial}/stream3/index.m3u8`,
  ];

  // Usa document.getElementById per ottenere il nodo target del portale
  const portalRoot = document.getElementById('boat-stream-portal-root');

  // Contenuto del portale ora avvolto da Draggable
  const portalContent = (
    <Draggable 
      handle=".video-player-hls-4flussi-header" // Specifica l'handle per il drag
      bounds="body" // Limita il drag ai confini del body
      // position={null} // Lascia che il CSS iniziale posizioni, poi draggable prende il controllo
      // defaultPosition={{x: 0, y: 0}} // Posizione iniziale relativa (0,0) del div target
    >
      <div className="video-player-hls-4flussi"> {/* Questo div viene mosso */} 
        <div className="video-player-hls-4flussi-header"> {/* Questo è l'handle */} 
          <h4>Streaming Barca: {serial}</h4>
          <button onClick={onClose} className="btn btn-sm btn-danger close-4flussi">
            Chiudi
          </button>
        </div>
        <div className="video-player-hls-4flussi-grid">
          {streamUrls.map((url, index) => (
            <div key={index} className="video-player-hls-4flussi-player">
              <VideoPlayerHlsSingoloFlusso
                videoStreaming={url}
              />
            </div>
          ))}
        </div>
      </div>
    </Draggable>
  );

  // Se il nodo target esiste, crea il portale, altrimenti non renderizzare nulla
  return portalRoot ? ReactDOM.createPortal(portalContent, portalRoot) : null;
};

export default VideoPlayerHls4Flussi; 